import PropTypes from 'prop-types'

import {List, Map} from 'immutable'
import {connect} from 'react-redux'
import {updateResource} from 'redux-json-api'

import ExistingItemPermissionInformation from '../manage_item_permissions/ExistingItemPermissionInformation'
import ManageItemPermissionsModal from '../manage_item_permissions/ManageItemPermissionsModal'

import {TextGutterMedium} from '../../../blocks/Texts'

import image from '../../../../../../shared_assets/quarterbackImage.png'

import './everplansConcierge.scss'

const EverplansConcierge = ({quarterbackOwnership, ...otherProps}) => {
  if (quarterbackOwnership.isEmpty()) return null

  return (
    <div className='everplans-concierge'>
      <div className='everplans-concierge__text'>
        <h2>Everplans Concierge</h2>
        <TextGutterMedium>
          Included with your subscription, a member of our Concierge Team will
          help you get started, stay on track, and build a plan that reflects
          your life.
        </TextGutterMedium>
        <ExistingItemPermissionInformation
          name='Everplans Concierge'
          ownership={quarterbackOwnership}
        />
        <ManageItemPermissionsModal
          isFuneralHome={!quarterbackOwnership.isEmpty()}
          items={otherProps.items}
          name='Everplans Concierge'
          ownership={quarterbackOwnership}
          updateResource={otherProps.updateResource}
        />
      </div>
      <img alt='' src={image} />
    </div>
  )
}

EverplansConcierge.propTypes = {
  items: PropTypes.instanceOf(List),
  quarterbackOwnership: PropTypes.instanceOf(Map),
  updateResource: PropTypes.func
}

const mapStateToProps = state => ({items: state.items})

export default connect(mapStateToProps, {updateResource})(EverplansConcierge)
